import A4Icon from './A4Icon';
import EntryGroupIcon from './EntryGroupIcon';
import M1Icon from './M1Icon';
import M2Icon from './M2Icon';
import M3Icon from './M3Icon';
import M4Icon from './M4Icon';
import M5Icon from './M5Icon';
import M7Icon from './M7Icon';
import M8Icon from './M8Icon';
import NCIcon from './NCIcon';
import WCXIcon from './WCXIcon';
import TollRoadIcon from './TollRoadIcon';
import CarIcon from './CarIcon';
import TruckBIcon from './TruckBIcon';
import QuestionMarkIcon from './QuestionMarkIcon';
import EntryIcon from './EntryIcon';
import ExitIcon from './ExitIcon';
import ConstructionIcon from './ConstructionIcon';
import AddressGroupIcon from "./AddressGroupIcon";
import TripOutlineIcon from "./TripOutlineIcon";
import BackdatingIcon from "./BackdatingIcon";
import RewardsIcon from "./RewardsIcon";
import WebsiteAppIcon from "./WebsiteAppIcon";
import SydneyPassIcon from "./SydneyPassIcon";
import TaglessIcon from "./TaglessIcon";
import LinktGOIcon from "./LinktGOIcon";
import TagIcon from "./TagIcon";
import BackIcon from "./BackIcon";
import ForwardIcon from "./ForwardIcon";
import CheckIcon from "./CheckIcon";
import CrossIcon from "./CrossIcon";
import ExclamationMarkIcon from './ExclamationMarkIcon';
import EntryTollIcon from './EntryTollIcon';
import ExitTollIcon from './ExitTollIcon'
import EastLinkM3Icon from './EastLinkM3Icon'
import CityLinkM1M2Icon from './CityLinkM1M2Icon';
import ExpandLessIcon from './ExpandLessIcon';
import ExpandMoreIcon from './ExpandMoreIcon';
import InfoIcon from './InfoIcon';
import WarningIcon from './WarningIcon';
import ErrorIcon from './ErrorIcon';
import PaymentIcon from "./Payment";
import DashIcon from "./DashIcon";
import WGTIcon from "./WGTIcon";

const Icons: { [key: string]: React.ElementType } = {
  A4Icon,
  EntryGroupIcon,
  M1Icon,
  M2Icon,
  M3Icon,
  M4Icon,
  M5Icon,
  M7Icon,
  M8Icon,
  NCIcon,
  WCXIcon,
  CityLinkM1M2Icon,
  EastLinkM3Icon,
  TollRoadIcon,
  CarIcon,
  TruckBIcon,
  QuestionMarkIcon,
  EntryTollIcon,
  EntryIcon,
  ExitIcon,
  ExitTollIcon,
  ConstructionIcon,
  AddressGroupIcon,
  TripOutlineIcon,
  BackdatingIcon,
  RewardsIcon,
  WebsiteAppIcon,
  SydneyPassIcon,
  TaglessIcon,
  LinktGOIcon,
  BackIcon,
  ForwardIcon,
  CheckIcon,
  CrossIcon,
  TagIcon,
  ExclamationMarkIcon,
  ExpandLessIcon,
  ExpandMoreIcon,
  InfoIcon,
  WarningIcon,
  ErrorIcon,
  PaymentIcon,
  DashIcon,
  WGTIcon
};

export default Icons;
